/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetcher } from "./fetcher";
import { queryKeys, mutationKeys } from "./queryKeys";

export const useInvoiceCreate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: mutationKeys.invoiceCreate,
    mutationFn: (data) => fetcher({ method: "POST", url: "/public/invoice", data }),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.invoices.all });

      if (data?.id) {
        queryClient.invalidateQueries({ queryKey: queryKeys.invoice.detail(data.id) });
      }
    },
  });
};
